import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { fontDefaultAlt } from '@mirinae/react-ui';

import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import IconList from '@mirinae/lessons/components/lesson/icons/IconList';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
import { HelpBubble, registerHelp } from '@mirinae/lessons/components/lesson/Help';

const ButtonWrapper = styled.div`
    :after {
        content: '';
        clear: both;
        display: block;
    }
`;
const Button = styled(LessonButton)`
    float: right;
    display: flex;
    align-items: center;
    padding: 9px 11px;
    border-radius: 20px;
    background: ${props => (props.listType === 'listButton' ? lessonsPalette.default[4] : lessonsPalette.default[3])};
    box-shadow: 0 3px 4px  ${props => (props.listType === 'listButton' ? 'rgba(132, 152, 170, 0.5)' : 'rgba(132, 152, 170, 0.5)')} , inset -1px -2px 4px rgba(66, 100, 132, 0.4), inset 6px 4px 4px rgba(204, 225, 245, 0.4);
    font-family: ${fontDefaultAlt};
    font-weight: 700;
    font-size: 13px;
    color: ${lessonsPalette.primary.white};
    span {
        transition: all 0.2s ease-in-out;
        display: block;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        &::before {
            content: '';
            display: inline-block;
            width: 5px;
        }
    }
    &:hover {
        span {
            width: 115px;
        }
    }
`;

const ListButton = ({ element }) => {
    const player = useContext(PlayerContext);

    return (
        <Element element={element}>
            <ButtonWrapper>
                <Button
                    data-t="lesson-list-btn" type="button" listType={element.type}
                    onClick={() => player.gotoPage(element.fieldsByName.destination.value, { fallbackPageType: element.type === 'listButton' ? 'MiniLessonTable' : 'IrregularMiniLessonNav' })}
                >
                    <IconList />
                    { element.fieldsByName.label && <span>{element.fieldsByName.label.value}</span> }
                </Button>
            </ButtonWrapper>
        </Element>
    );
};

registerHelp(ListButton, [
    <HelpBubble
        title="Mini-lesson directory"
        desktop={{ anchor: '.el-listButton', titleAt: 'top', arrowPos: 'right', arrowDir: 'up', style: { top: 41, right: 0, contentWidth: 280 } }}
        mobile={{ anchor: '.el-listButton', titleAt: 'top', arrowPos: 'right', arrowDir: 'up', style: { top: 41, right: 0, contentWidth: 200 } }}>
        <p>Click the mini-lesson button to go back to the main mini-lesson summary page.</p>
        <p>You can navigate to other mini-lessons from that page, or click Skip on that page to proceed with the main lesson.
        </p>
    </HelpBubble>,
]);

export default ListButton;
